import {
  Anchor,
  Box,
  Button,
  Divider,
  Group,
  PinInput,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import LanguageChanger from "../LanguageChanger";
import { useLanguage } from "../../../stores/LanguageStore";
import { useSessionStore } from "../../../stores/UserStore";
import LogoHorizontalWhite from "../../../layouts/LogoHorizontalWhite";
import { lemonColor } from "../../../stores/ThemeStore";
import LoginDecorations from "../login/LoginDecorations";
import { Logo } from "../../../layouts/Logo";
import { useState } from "react";
import { smsConfirmAccount, smsConfirmResend } from "../../../api/AuthAPI";
import { notifications } from "@mantine/notifications";

const SignupSmsConfirmation = () => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const params = new URLSearchParams(location.search)
  const phone_number_country = params.get("country");
  const phone_number = params.get("phone");

  const [errorCode, setErrorCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const navigate = useNavigate()
  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);

    smsConfirmAccount({ code: data.code })
      .then((response) => {
        navigate("/success/account")
      })
      .catch((error) => {
        if (error.response.data.state_message === "incorrect_code") {
          setErrorCode(true);
          document.getElementById("code-input").focus();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleResend = () => {
    setResending(true);

    smsConfirmResend({
      domain_saas: reseller?.domain_saas3 || reseller?.domain_saas2,
      mobile_phone: phone_number,
      mobile_phone_country: phone_number_country,
    })
      .then(() => {
        notifications.show({
          message: lang.signup.sms_confirmation.resend_success,
        });
      })
      .finally(() => {
        setResending(false);
      });
  };

  return (
    <Group
      w={"100vw"}
      h={"100vh"}
      gap={0}
      bg={"#392b5f"}
      align="stretch"
      c={"#392b5f"}
      style={{ overflow: "hidden" }}
    >
      <Stack
        w={"50%"}
        px={100}
        justify="start"
        h={"100%"}
        pos={"relative"}
        style={{ zIndex: 8 }}
        bg={"primary.9"}
        display={{ lg: "flex", base: "none" }}
      >
        <Box h={100} maw={350} mb={96} pos={"absolute"} top={48}>
          <LogoHorizontalWhite />
        </Box>
        {/* <Logo /> */}

        <Title order={4} pl={100} mt={256} fz={44} lh={1.4} c={"white"}>
          {lang.login.title1} {lang.id === "FRA" && <br />}
          <span
            style={{
              color: lemonColor,
            }}
          >
            {lang.login.title2}
          </span>{" "}
          {lang.login.title3}{" "}
          {lang.id === "FRA" && (
            <>
              {" "}
              <br /> {lang.login.title4} <br />
            </>
          )}
          <span
            style={{
              color: lemonColor,
            }}
          >
            {lang.login.title5}
          </span>
        </Title>

        <Text c={"white"} mt={"auto"} mb={32}>
          {reseller?.name || "Magileads"} • {new Date().getFullYear()}
        </Text>
      </Stack>

      <Stack
        flex={1}
        p={{ base: 0, lg: "lg" }}
        bg={reseller?.name !== "Magileads" ? "primary.0" : "#f1e9fe"}
        justify="center"
        align="center"
        pos={"relative"}
      >
        <Stack
          w={{ base: "90%", lg: "60%" }}
          gap={"xs"}
          style={{ zIndex: 8 }}
          align="center"
          component={"form"}
          onSubmit={handleSubmit}
        >
          {window.innerWidth < 768 && (
            <Box
              h={100}
              maw={200}
              mb={96}
              pos={"absolute"}
              top={16}
              style={{ zIndex: 9 }}
            >
              <Logo />
            </Box>
          )}
          <Title
            order={1}
            className={`animate__animated animate__fadeIn`}
            mb={8}
          >
            {lang.signup.sms_confirmation.title}
          </Title>

          <Text size="lg">{lang.signup.sms_confirmation.text} : </Text>
          <Text size="xl" fw={600}>
            {phone_number}
          </Text>
          <Text size="lg">{lang.signup.sms_confirmation.text2}</Text>
          <PinInput
            name="code"
            id="code-input"
            size="lg"
            mt={4}
            length={6}
            aria-required
            error={errorCode}
          />

          <Button size="md" w={300} mt={18} type="submit" loading={loading}>
            {lang.signup.sms_confirmation.verify}
          </Button>

          <Text mt={16}>
            {lang.signup.sms_confirmation.resend_text}
            <Anchor
              onClick={resending ? undefined : handleResend}
              opacity={resending ? 0.5 : 1}
            >
              {" "}
              {lang.signup.sms_confirmation.resend_link}
            </Anchor>
          </Text>
        </Stack>

        <LoginDecorations />
      </Stack>
      <LanguageChanger />
    </Group>
  );
};

export default SignupSmsConfirmation;
